module.exports = __webpack_public_path__ + "img/TiNPad-圆形-Inpillar-方形.ceff4c1a.svg";